import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BusinessObject } from '@libs/index';
import { BusinessObjectUtils } from '@libs/index';
import { BreakpointService } from '@libs/index';

@Component({
  selector: 'app-button-bar-for-selected-service',
  templateUrl: './button-bar-for-selected-service.component.html',
  styleUrls: ['./button-bar-for-selected-service.component.scss'],
})
export class ButtonBarForSelectedServiceComponent {
  private _businessObject: BusinessObject;
  @Input() set businessObject(value: BusinessObject) {
    this._businessObject = value;
    this.updateSubmitButtonBarData();
  }
  get businessObject(): BusinessObject {
    return this._businessObject;
  }

  private _selectedProductIds: number[];
  @Input() set selectedProductIds(value: number[]) {
    this._selectedProductIds = [...(value || [])];
    this.updateSubmitButtonBarData();
  }
  get selectedProductIds(): number[] {
    return this._selectedProductIds;
  }

  private _selectedDate: Date;
  @Input() set selectedDate(value: Date) {
    this._selectedDate = value;
    this.updateSubmitButtonBarData();
  }
  get selectedDate(): Date {
    return this._selectedDate;
  }

  private _requireSelectedDateToCalculateDiscount = false;
  @Input() set requireSelectedDateToCalculateDiscount(value: boolean) {
    this._requireSelectedDateToCalculateDiscount = value;
    this.updateSubmitButtonBarData();
  }
  get requireSelectedDateToCalculateDiscount(): boolean {
    return this._requireSelectedDateToCalculateDiscount;
  }

  @Input() isLoading: boolean;

  @Input() buttonLabel: string;
  @Input() isDisabledButton: boolean;
  @Input() customHintText: string;

  @Output() buttonClicked = new EventEmitter<any>();

  public nameOfSelectedService: string;

  public totalSelectedServices: number;
  public totalPrice: number;
  public totalDiscountedPrice: number;
  public totalDuration: number;
  public isAnySelectedServiceInDiscount: boolean;

  constructor(public breakpointService: BreakpointService) {}

  private updateSubmitButtonBarData(): void {
    const selectedProductIdSet = new Set<number>(this.selectedProductIds || []);

    this.nameOfSelectedService = null;

    this.totalSelectedServices = selectedProductIdSet.size;

    this.totalPrice = 0;
    this.totalDiscountedPrice = 0;
    this.totalDuration = 0;
    this.isAnySelectedServiceInDiscount = false;

    const selectedDate = this.selectedDate || new Date();

    this.businessObject?.categories?.forEach((c) => {
      c?.products
        ?.filter((p) => selectedProductIdSet.has(p.id))
        ?.forEach((p) => {
          if (!this.nameOfSelectedService) {
            this.nameOfSelectedService = p.name;
          } else {
            this.nameOfSelectedService = `${this.nameOfSelectedService}, ${p.name}`;
          }

          this.totalPrice += p.price;
          this.totalDuration += p.duration;

          if (
            this.requireSelectedDateToCalculateDiscount &&
            !this.selectedDate
          ) {
            this.totalDiscountedPrice += p.price;
          } else if (
            BusinessObjectUtils.isAnyDiscountActivatedAtTimeStamp(
              p,
              selectedDate
            )
          ) {
            this.totalDiscountedPrice +=
              BusinessObjectUtils.getPromotionalPrice(p, selectedDate);
            this.isAnySelectedServiceInDiscount = true;
          } else {
            this.totalDiscountedPrice += p.price;
          }
        });
    });
  }
}
